// Resolved at request time so the async config.json load can populate
// window.__QDF_API_URL__ before the first API call.
function getApiBaseUrl(): string {
  return window.__QDF_API_URL__
    || import.meta.env.VITE_API_URL
    || '';
}

export class ApiError extends Error {
  constructor(
    public status: number,
    public body: { error: string; message: string; details?: Record<string, string[]> },
  ) {
    super(body.message);
    this.name = 'ApiError';
  }
}

export async function apiRequest<T>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const url = `${getApiBaseUrl()}${path}`;
  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

  const body = await response.json();

  if (!response.ok) {
    throw new ApiError(response.status, body);
  }

  return body as T;
}
